import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 overflow-y-auto" }
const _hoisted_2 = { class: "flex min-h-full items-center justify-center p-4 text-center" }
const _hoisted_3 = {
  key: 0,
  class: "flex items-center justify-between p-6 border-b border-gray-200 dark:border-gray-700"
}
const _hoisted_4 = {
  key: 1,
  class: "flex items-center justify-end space-x-3 p-6 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50"
}

import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionRoot,
  TransitionChild,
} from '@headlessui/vue'

interface Props {
  isOpen: boolean
  title?: string
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full'
  showCloseButton?: boolean
  contentClass?: string
  customClass?: string
}

interface Emits {
  (e: 'close'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    isOpen: { type: Boolean },
    title: {},
    size: { default: 'md' },
    showCloseButton: { type: Boolean, default: true },
    contentClass: { default: '' },
    customClass: { default: '' }
  },
  emits: ["close"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    appear: "",
    show: _ctx.isOpen,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close'))),
        class: "relative z-50"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "duration-300 ease-out",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "duration-200 ease-in",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [
              _createElementVNode("div", { class: "fixed inset-0 bg-black/25 backdrop-blur-sm" }, null, -1)
            ])),
            _: 1,
            __: [2]
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "duration-300 ease-out",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "duration-200 ease-in",
                "leave-from": "opacity-100 scale-100",
                "leave-to": "opacity-0 scale-95"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    class: _normalizeClass([
                'w-full transform overflow-hidden rounded-2xl bg-white dark:bg-gray-800 text-left align-middle shadow-xl transition-all border border-gray-200 dark:border-gray-700',
                _ctx.size === 'sm' && 'max-w-md',
                _ctx.size === 'md' && 'max-w-lg',
                _ctx.size === 'lg' && 'max-w-2xl',
                _ctx.size === 'xl' && 'max-w-4xl',
                _ctx.size === '2xl' && 'max-w-6xl',
                _ctx.size === 'full' && 'max-w-7xl',
                _ctx.customClass
              ])
                  }, {
                    default: _withCtx(() => [
                      (_ctx.title || _ctx.$slots.header)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _renderSlot(_ctx.$slots, "header", {}, () => [
                              _createVNode(_unref(DialogTitle), {
                                as: "h3",
                                class: "text-lg font-semibold text-gray-900 dark:text-white"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.title), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            (_ctx.showCloseButton)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
                                  class: "rounded-lg p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
                                }, _cache[3] || (_cache[3] = [
                                  _createElementVNode("svg", {
                                    class: "w-5 h-5",
                                    fill: "none",
                                    stroke: "currentColor",
                                    viewBox: "0 0 24 24"
                                  }, [
                                    _createElementVNode("path", {
                                      "stroke-linecap": "round",
                                      "stroke-linejoin": "round",
                                      "stroke-width": "2",
                                      d: "M6 18L18 6M6 6l12 12"
                                    })
                                  ], -1)
                                ])))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(['p-6', _ctx.contentClass])
                      }, [
                        _renderSlot(_ctx.$slots, "default")
                      ], 2),
                      (_ctx.$slots.footer)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _renderSlot(_ctx.$slots, "footer")
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})